import { Grid, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';

import Button from '@/contents/General/Button';
import Chip from '@/contents/General/Chip';
import Icon from '@/contents/General/Icon';
import Image from '@/contents/General/Image';
import { UserIcon } from '@/contents/General/Panels';
import { GlobalContext } from '@/contents/hooks/state';
import theme from '@/styles/theme';
import type { PublicUser } from '@/types/domain';
import { Page } from '@/types/domain';
import ImageUrlConvert from '@/utils/ImageUrlConvert';

const HeaderNavi = styled(Box)<{ is_pc: string }>`
  display: flex;
  align-item: center;
  position: fixed;
  padding: 0 ${theme.spacing(3)};
  width: 100%;
  height: 57px;
  background: #ffffff;
  z-index: 10;
  ${(props) => !props.is_pc && `top: 64px;  border-top: solid 1px #f4f8f6;`}
  ${(props) => props.is_pc && `max-width: 506px; border-radius: 40px 40px 0 0`}
`;

export const CamperMenu = ({ user }: { user: PublicUser }) => {
  const router = useRouter();
  const { page } = useContext(GlobalContext);
  const isPC = useMediaQuery('(min-width:900px)');

  const nextPage = (path: string) => {
    router.push(`/camper/${user.id}/${path}`);
  };

  return (
    <HeaderNavi is_pc={isPC ? isPC.toString() : ''}>
      <Grid container>
        <Grid item xs={3}>
          <Button
            onClick={() => nextPage('')}
            component="label"
            sx={{ width: '100%', height: '100%' }}
          >
            <Box
              position="relative"
              height={
                !!user &&
                typeof user === 'object' &&
                typeof user.icon?.file_name === 'string'
                  ? 36
                  : 28
              }
            >
              {!!user &&
              typeof user === 'object' &&
              typeof user.icon?.file_name === 'string' ? (
                <UserIcon icon_height={36}>
                  <Image
                    src={ImageUrlConvert(user.icon?.file_name, true)}
                    width={36}
                    height={36}
                    alt={`${user.display_name}のアイコン`}
                  />
                </UserIcon>
              ) : (
                <Icon
                  iconType="mypage-account"
                  color={page === Page.CAMPER_ACCOUNT ? 'primary' : ''}
                />
              )}
            </Box>
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            onClick={() => nextPage('favorite')}
            component="label"
            sx={{ width: '100%', height: '100%' }}
          >
            <Box position="relative" height={28}>
              <Icon
                iconType="mypage-favorite"
                color={page === Page.CAMPER_FAVORITE ? 'primary' : ''}
              />
              <Chip
                label={user?.total_like_num ?? 0}
                chipColor="secondary"
                sx={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  maxWidth: '48px',
                }}
              />
            </Box>
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            onClick={() => nextPage('log')}
            component="label"
            sx={{ width: '100%', height: '100%' }}
          >
            <Box position="relative" height={28}>
              <Icon
                iconType="mypage-review"
                color={page === Page.CAMPER_REVIEW ? 'primary' : ''}
              />
              <Chip
                label={user.total_review_num ?? 0}
                color="secondary"
                chipColor="secondary"
                sx={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  maxWidth: '48px',
                }}
              />
            </Box>
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            onClick={() => nextPage('visited')}
            component="label"
            sx={{ width: '100%', height: '100%' }}
          >
            <Box position="relative" height={28}>
              <Icon
                iconType="mypage-visit"
                color={page === Page.CAMPER_VISITED ? 'primary' : ''}
              />
              <Chip
                label={user.total_visited_num ?? 0}
                chipColor="secondary"
                sx={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  maxWidth: '48px',
                }}
              />
            </Box>
          </Button>
        </Grid>
      </Grid>
    </HeaderNavi>
  );
};
